//#region src/rbac/teamRole.ts
let TeamRole = /* @__PURE__ */ function(TeamRole) {
	TeamRole["Admin"] = "admin";
	TeamRole["Developer"] = "developer";
	TeamRole["Viewer"] = "viewer";
	return TeamRole;
}({});
const ROLE_LABELS = {
	["admin"]: "Admin",
	["developer"]: "Developer",
	["viewer"]: "Viewer"
};
const LEGACY_ROLES = ["admin", "developer"];
const RBAC_ROLES = [...LEGACY_ROLES, "viewer"];
//#endregion
export { LEGACY_ROLES, RBAC_ROLES, ROLE_LABELS, TeamRole };

//# sourceMappingURL=teamRole.js.map